import React from 'react';
import { string, number, bool, shape } from 'prop-types';

import { Image } from 'nordic/image';
import { Button } from '@andes/button';

import { trackEvent } from '../../../../lib/melidata';

const SeeMoreCard = ({ action, description, permalink, picture, track, hasExtraSpacing }) => {
  const handleClick = () => {
    if (track !== null) {
      trackEvent({
        clean: true,
        path: track?.path,
        event_data: { ...track?.event_data },
      });
    }
  };

  return (
    <div className={`end-card ${hasExtraSpacing ? 'button-with-label' : 'button-without-label'}`}>
      <div className="end-card-content">
        <Image alt="" src={picture.url} className="end-card-image" />
        <p className="end-card-text">{description.text}</p>
        <Button
          aria-hidden="true"
          hierarchy="loud"
          size="medium"
          type="button"
          srLabel={action?.accessibility_text || action?.text}
          href={action.deeplink || permalink}
          onClick={handleClick}
          className="end-card-button"
        >
          {action.text}
        </Button>
      </div>
    </div>
  );
};

SeeMoreCard.propTypes = {
  action: shape({
    text: string,
    deeplink: string,
  }),
  description: shape({
    color: string,
    font_family: string,
    font_size: string,
    text: string,
  }),
  hasExtraSpacing: bool,
  permalink: string,
  picture: shape({
    url: shape({
      src: string,
    }),
  }),
  track: shape({
    event_data: shape({
      intervention_tracking_id: string,
      group_type: string,
      flow_type: string,
      got_free_shipping: bool,
      intervention_position: number,
      view_all_products_link: string,
    }),
    path: string,
  }),
};

export default SeeMoreCard;
